// language tag (alphanumerics, +, -, _, .) and nothing else. Anything else
// on the line means it's not a well-formed fence.
export const CODE_FENCE_RE = /^```([A-Za-z0-9_+\-.]*)\s*$/

// Box-drawing characters (Unicode U+2500–U+257F). Any line that contains
// one of these is almost certainly part of an ASCII tree, directory
// listing, or architecture diagram and should be rendered verbatim with
// preserved newlines — never collapsed into prose.
export const BOX_DRAW_RE = /[\u2500-\u257F]/

// ATX-style markdown heading: 1–6 leading hashes, then a space, then the
// heading text. We deliberately require the space so we don't catch lines
// like `#topic` or `#1` that aren't really headings.
export const HEADING_RE = /^(#{1,6})\s+(.+?)\s*#*\s*$/

// Markdown blockquote: line starts with `>` optionally followed by space.
export const BLOCKQUOTE_RE = /^>\s?(.*)$/
